import * as fromDatatype from "../../../../models/datatype-library";


export class WmsReceivingDocSearchCriteriaDtoModel {
    has_line?: boolean ;
    has_link?: boolean;
    guid?: fromDatatype.GuidDataFieldInterface;
    warehouse_guid?: fromDatatype.GuidDataFieldInterface;
    owner_entity_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    owner_comp_guid?: fromDatatype.GuidDataFieldInterface;
    owner_branch_guid?: fromDatatype.GuidDataFieldInterface;
    sending_entity_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    logistic_entity_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    reference_no?: string;
    process_status?: string;
    tracking_id?:string;
    guids?:any[];
    created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    created_date_from?: fromDatatype.TimestampTzDatatypeInterface; 
    updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    updated_date_from?: fromDatatype.TimestampTzDatatypeInterface; 
    server_doc_type?: string;
    server_doc_1?: string;
    client_doc_1?: string;
    warehouse_guids?: any[];
    owner_entity_hdr_guids?: any[];
    owner_comp_guids?: any[];
    owner_branch_guids?: any[];
    line_guid?: fromDatatype.GuidDataFieldInterface;
    line_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    line_owner_entity_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    line_owner_comp_guid?: fromDatatype.GuidDataFieldInterface;
    line_owner_branch_guid?: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid?: fromDatatype.GuidDataFieldInterface;
    item_code?: string;
    item_subtype?: string;
    line_tracking_id?: string;
    line_guids?: any[];
    line_hdr_guids?: any[];
    link_guid?: fromDatatype.GuidDataFieldInterface;
    link_guid_doc_1_hdr?: fromDatatype.GuidDataFieldInterface;
    link_guid_doc_1_line?: fromDatatype.GuidDataFieldInterface;
    link_guid_doc_2_hdr?: fromDatatype.GuidDataFieldInterface;
    link_guid_doc_2_line?: fromDatatype.GuidDataFieldInterface;
}
